import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../hooks/useLanguage';
import './InnerPageHeader.css';

function InnerPageHeader({ 
  title, 
  description, 
  breadcrumbItems = [],
  backgroundImage = "/home1/assets/img/slider/1.jpg",
  className = ""
}) {
  const { t } = useTranslation();
  const { changeLanguage, isCurrentLanguage } = useLanguage();

  const NAV_LINKS = [
    { label: t('navigation.home'), href: '/' },
    { label: t('navigation.project'), href: '/innerpages/portfolio' },
    { label: t('navigation.about'), href: '/home7_landscape/' },
    { label: t('navigation.contact'), href: '/innerpages/contact' },
  ];

  const LANGUAGE_SWITCH = [
    { label: t('language.en'), code: 'en' },
    { label: t('language.bg'), code: 'bg' },
  ];

  return (
    <header className={`tc-inner-page-header ${className}`}>
      {/* Background Image */}
      <div className="header-background">
        <div className="bg-image">
          <img src={backgroundImage} alt="" className="img-cover" />
        </div>
        <div className="bg-overlay"></div>
      </div>

      {/* Navigation Bar */}
      <nav className="navbar navbar-expand-lg navbar-dark tc-navbar-style1 section-padding-x">
        <div className="container-fluid content">
          <a className="navbar-brand" href="/">
            <img src="/home1/assets/img/logo_light.png" alt="Logo" className="logo" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0" style={{ width: '100%' }}>
              {NAV_LINKS.map((link, index) => (
                <li className="nav-item" key={index}>
                  <a
                    className={`nav-link${window.location.pathname === link.href ? ' active' : ''}`}
                    href={link.href}
                    style={{ padding: '10px 20px', fontWeight: 500 }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className="nav-side d-flex align-items-center">
              {LANGUAGE_SWITCH.map((lang, index) => (
                <a 
                  href="#" 
                  className={`icon ms-3 ${isCurrentLanguage(lang.code) ? 'active' : ''}`} 
                  key={index}
                  onClick={(e) => {
                    e.preventDefault();
                    changeLanguage(lang.code);
                  }}
                  style={{
                    opacity: isCurrentLanguage(lang.code) ? 1 : 0.7,
                    fontWeight: isCurrentLanguage(lang.code) ? 'bold' : 'normal'
                  }}
                >
                  <span>{lang.label}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </nav>

      {/* Page Title Section */}
      <div className="page-title-section">
        <div className="container section-padding-x">
          <div className="row">
            <div className="col-lg-8">
              <div className="page-title-content">
                {breadcrumbItems.length > 0 && (
                  <nav aria-label="breadcrumb" className="mb-3">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a href="/" className="text-muted">
                          {t('navigation.home')}
                        </a>
                      </li>
                      {breadcrumbItems.map((item, index) => (
                        <li 
                          key={index}
                          className={`breadcrumb-item ${index === breadcrumbItems.length - 1 ? 'active' : ''}`}
                          aria-current={index === breadcrumbItems.length - 1 ? 'page' : undefined}
                        >
                          {item.href && index !== breadcrumbItems.length - 1 ? (
                            <a href={item.href} className="text-muted">
                              {item.label}
                            </a>
                          ) : (
                            item.label
                          )}
                        </li>
                      ))}
                    </ol>
                  </nav>
                )}
                <h1 className="page-title">
                  {title}
                </h1>
                {description && (
                  <p className="page-subtitle text-muted mt-3">
                    {description}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default InnerPageHeader; 